import { getAccessTokenFromCookie } from "../../util/authentication";
import { CFG_BID, SYSTEM_API_COMMON_CONFIG } from "../../util/constants";

// GET functions
export const getPermanentBidPositionsByContract = async (contract) => {
  const apiEndpoint =
    process.env.REACT_APP_SYSTEM_SERVICE_API +
    SYSTEM_API_COMMON_CONFIG +
    "/" +
    CFG_BID.POSITIONS_MAP_NAME +
    "/" +
    contract;
  try {
    const response = await fetch(apiEndpoint, {
      headers: {
        "Content-Type": "application/json",
        authorization: "Bearer " + getAccessTokenFromCookie(),
      },
    });
    return response;
  } catch (error) {
    console.log(error);
    return null;
  }
};

export const getAllPermanentBidPositions = async () => {
  const apiEndpoint =
    process.env.REACT_APP_SYSTEM_SERVICE_API +
    SYSTEM_API_COMMON_CONFIG +
    "/" +
    CFG_BID.POSITIONS_MAP_NAME +
    "/" +
    CFG_BID.ALL;
  try {
    const response = await fetch(apiEndpoint, {
      headers: {
        "Content-Type": "application/json",
        authorization: "Bearer " + getAccessTokenFromCookie(),
      },
    });
    return response;
  } catch (error) {
    console.log(error);
    return null;
  }
};

export const getBidTypeFeaturesByStation = async (station) => {
  const apiEndpoint =
    process.env.REACT_APP_SYSTEM_SERVICE_API + SYSTEM_API_COMMON_CONFIG + "/" + CFG_BID.BID_TYPE + "/" + station;
  try {
    const response = await fetch(apiEndpoint, {
      headers: {
        "Content-Type": "application/json",
        authorization: "Bearer " + getAccessTokenFromCookie(),
      },
    });
    return response;
  } catch (error) {
    console.log(error);
    return null;
  }
};
